import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=afbac298&scoped=true&"
import script from "./JobsList.vue?vue&type=script&lang=js&"
export * from "./JobsList.vue?vue&type=script&lang=js&"
import style0 from "./JobsList.vue?vue&type=style&index=0&id=afbac298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbac298",
  null
  
)

export default component.exports